// extracted by mini-css-extract-plugin
export default {"back-to-top":"to-top-button_back-to-top__R9DQu"};